if (!location.hash)
  location.href = '#donate'